import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/grns/$grnId")({
  component: () => <Outlet />,
});
